// https://jira.makolab.net/browse/NBSS-13998
// In-page simulator: Temporary footer UI
// IMPORTANT! Remember to remove this block after removing temporary Toyota dependencies for in-page-simulator!
export function addInPageFooterUI(productUI, flowId, inBody, level, order, containerId, containerClass, buttonClass, requestConfiguration, sendEventToServer, customUiDescription, resultData, additionalData) {
    if (inBody === void 0) { inBody = false; }
    if (level === void 0) { level = 2; }
    if (order === void 0) { order = 100; }
    if (containerId === void 0) { containerId = ''; }
    if (containerClass === void 0) { containerClass = ''; }
    if (buttonClass === void 0) { buttonClass = 'bss-button_btn--secondary bss-button_btn--inline bss-m-0'; }
    if (requestConfiguration === void 0) { requestConfiguration = {}; }
    if (sendEventToServer === void 0) { sendEventToServer = false; }
    if (customUiDescription === void 0) { customUiDescription = function () { return []; }; }
    if (resultData === void 0) { resultData = null; }
    var productId = productUI[0].productId[0];
    // Add in-page footer UI to each product UI description
    var customUiDesc = customUiDescription(flowId, productId, inBody, level, order, containerId, containerClass, buttonClass, requestConfiguration, sendEventToServer, resultData, additionalData);
    return productUI.concat(customUiDesc.length > 0 ? customUiDesc :
        generateInPageFooterUIDescription(flowId, productId, inBody, level, order, containerId, containerClass, buttonClass, requestConfiguration, sendEventToServer));
}
function generateInPageFooterUIDescription(flowId, productId, inBody, level, order, containerId, containerClass, buttonClass, requestConfiguration, sendEventToServer) {
    return [
        {
            componentId: "footerContainerInPage_".concat(productId),
            testId: 'footerContainerInPage',
            componentTemplate: 'componentContainer',
            componentType: 'TemplateComponent',
            containerId: containerId.length ? "".concat(containerId).concat(productId, "_content") : "navigationTabs_tab-content-".concat(productId),
            // max level to show always at the end of the simulator independently of usage
            level: level,
            order: order,
            productId: [productId, 'general'],
            class: "bss-in-page_footer ".concat(containerClass),
        },
        {
            componentId: "buttonConfirmAndCloseInPage_".concat(productId),
            testId: 'buttonConfirmAndCloseInPage',
            containerId: "footerContainerInPage_".concat(productId, "_content"),
            componentType: 'ButtonComponent',
            productId: [productId, 'general'],
            // max level to show always at the end of the simulator independently of usage
            level: level,
            order: order,
            isPublicEvent: false,
            sendEventToServer: sendEventToServer,
            text: "<value data-text='general.confirm_and_close_msg'></value>",
            onClickEvent: "bss-close-entity-".concat(flowId),
            class: buttonClass,
            requestConfiguration: requestConfiguration
        },
    ];
}
